import dayjs, { Dayjs } from "dayjs";
import { z } from "zod";

export const schema = z.object({
    title: z.string(),
    email: z.string().email("forms.general-validation.invalid_email_format"),
    status: z.string(),
    commission_group_id: z.string(),
    created_at: z.custom<Dayjs>((value) => dayjs.isDayjs(value), {
        message: "forms.general-validation.must_be_valid_dayjs",
    }),
    updated_at: z.custom<Dayjs>((value) => dayjs.isDayjs(value), {
        message: "forms.general-validation.must_be_valid_dayjs",
    }),
});

export type AffiliateOfferFormData = z.infer<typeof schema>;
